import { render, staticRenderFns } from "./IconGroeneWarmte.vue?vue&type=template&id=a65c3efa"
import script from "./IconGroeneWarmte.vue?vue&type=script&lang=ts"
export * from "./IconGroeneWarmte.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports